import React, { useContext } from "react";

import { Box, Grid, Theme, Typography, useTheme } from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import DairyIcon from "@components/Icons/Dairy";
import Fat from "@components/Icons/Fat";
import Fruit from "@components/Icons/Fruit";
import MeatIcon from "@components/Icons/Meat";
import Starch from "@components/Icons/Starch";
import Sugar from "@components/Icons/Sugar";
import Vegetable from "@components/Icons/Vegetable";

import MealPlanFormStore from "../store/MealPlanFormStore";

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    width: "100%",
    padding: 0,
    borderLeft: "1px solid #EDF0F5",
  },
  foodExchangeItem: {
    borderBottom: "1px solid #EDF0F5",
    borderRight: "1px solid #EDF0F5",
    padding: theme.spacing(2),
    display: "flex",
  },
  label: {
    textTransform: "capitalize",
  },
  value: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  dairy: {
    borderRight: "1px solid #EDF0F5",
    padding: theme.spacing(2, 4),
  },
  bold: {
    fontWeight: "bold",
    textTransform: "capitalize",
  },
}));

const FoodExchangeGuide: React.FC = observer(() => {
  const { classes } = useStyles();
  const theme = useTheme();

  const store = useContext(MealPlanFormStore.Context);
  const foodExchange = store.foodExchange;

  if (!foodExchange.use) {
    return null;
  }

  const foodExchangeArray = [
    { label: "Fat", value: foodExchange.values.fatsAndOil, icon: <Fat /> },
    { label: "Fruit", value: foodExchange.values.fruits, icon: <Fruit /> },
    { label: "Sugar", value: foodExchange.values.treats, icon: <Sugar /> },
    {
      label: "Vegetable",
      value: foodExchange.values.vegetables,
      icon: <Vegetable />,
    },
    {
      label: "Starches",
      value: foodExchange.values.starches,
      icon: <Starch />,
    },
  ];

  const meatArray = [
    {
      label: "Meat and Seafood",
      value: foodExchange.values.starches,
    },
    {
      label: "Plant-based Meat",
      value: foodExchange.values.plantBasedMeat,
    },
  ];
  const milkArray = [
    { label: "", value: foodExchange.values.dairy, icon: <DairyIcon /> },
  ];

  return (
    <div className={classes.root}>
      <Grid container>
        {/* Food exchange icons */}
        {foodExchangeArray.map((fe) => (
          <Grid item xs key={fe.label}>
            <div className={classes.foodExchangeItem}>
              <span>{fe.icon}</span>
              <Box marginLeft={theme.spacing(0.2)}>
                <Typography className={classes.bold}>{fe.label}</Typography>
                <Typography className={classes.value}>{fe.value}</Typography>
              </Box>
            </div>
          </Grid>
        ))}
      </Grid>
      <Grid container>
        {/* Dairy and meat */}
        <Grid item xs={6}>
          <div className={classes.dairy}>
            <Box display="flex">
              <span>
                <MeatIcon />
              </span>
              <Box marginLeft={theme.spacing(0.2)} />
              <Typography className={classes.bold}>Meat</Typography>
            </Box>
            {meatArray.map((ma) => (
              <Box
                key={ma.label}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography className={classes.label} variant="caption">
                  {ma.label}
                </Typography>
                <Typography className={classes.value}>{ma.value}</Typography>
              </Box>
            ))}
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className={classes.dairy}>
            <Box display="flex">
              <span>
                <DairyIcon />
              </span>
              <Box marginLeft={theme.spacing(0.2)} />
              <Typography className={classes.bold}>Dairy</Typography>
            </Box>
            {milkArray.map((ma) => (
              <Box
                key={ma.label}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography className={classes.label} variant="caption">
                  {ma.label}
                </Typography>
                <Typography className={classes.value}>{ma.value}</Typography>
              </Box>
            ))}
          </div>
        </Grid>
      </Grid>
    </div>
  );
});

export default FoodExchangeGuide;
